import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, styled } from '@mui/material'
import {
    AttentionIcon,
    FilledCheckIcon,
    CloseIcon,
    InfoIcon,
} from '../../eid-icons'

const icons = {
    success: <FilledCheckIcon />,
    warning: <AttentionIcon />,
    information: <InfoIcon />,
}

const colors = {
    success: '#029435',
    warning: '#d0021b',
    information: '#3792cb',
}

const NotificationRoot = styled(Box)(({ type }) => ({
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    width: '35rem',
    borderRadius: '0.5rem',
    color: '#fff',
    padding: '2rem',
    borderBottom: `1rem solid ${colors[type]}`,
    fontSize: '1.6rem',
}))

const NotificationMessage = React.forwardRef(
    ({ type, message, onClose }, ref) => {
        return (
            <NotificationRoot type={type}>
                <Box display="flex" alignItems="center" ref={ref}>
                    <Box flex="0.2" display="flex" alignItems="center">
                        {icons[type]}
                    </Box>
                    <Box flex="0.8">
                        <Typography variant="body2" sx={{ fontSize: '1.6rem' }}>
                            {message}
                        </Typography>
                    </Box>
                    <Box flex="0.2" display="flex" justifyContent="flex-end">
                        <span style={{ cursor: 'pointer' }} onClick={onClose}>
                            <CloseIcon />
                        </span>
                    </Box>
                </Box>
            </NotificationRoot>
        )
    },
)

NotificationMessage.propTypes = {
    type: PropTypes.oneOf(['success', 'warning', 'information']).isRequired,
    message: PropTypes.string.isRequired,
}

export default NotificationMessage
